import React from 'react';
import { colors } from '../theme';
import IProps from './interface';

const LinkedinViewProfileIcon = ({
  color = colors.black,
  className,
  onClick,
  style,
  size = 16,
}: IProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
      {...style}
    >
      <path
        d="M4 16H8.22984C8.22984 16 7.5 15.5 6.88051 14.6667H4C2.5296 14.6667 1.33333 13.4704 1.33333 12V4C1.33333 2.5296 2.5296 1.33333 4 1.33333H12C13.4704 1.33333 14.6667 2.5296 14.6667 4V10.037C14.9444 10.1808 15.6 10.7022 16 11.1022V4C16 1.7944 14.2056 0 12 0H4C1.7944 0 0 1.7944 0 4V12C0 14.2056 1.7944 16 4 16Z"
        fill={color}
      />
      <path
        d="M5.33333 6.6064V11.3333C5.33333 11.7015 5.0348 12 4.66667 12C4.29853 12 4 11.7015 4 11.3333V6.6064C4 6.23827 4.29853 5.93974 4.66667 5.93974C5.0348 5.93974 5.33333 6.23827 5.33333 6.6064ZM4.66667 3.73334C4.29853 3.73334 4 4.03187 4 4.4V4.53334C4 4.90147 4.29853 5.2 4.66667 5.2C5.0348 5.2 5.33333 4.90147 5.33333 4.53334V4.4C5.33333 4.03187 5.0348 3.73334 4.66667 3.73334ZM10.2025 6.02907C9.53613 5.89814 8.71347 6.07214 7.9968 6.63627C7.98 6.28307 7.69067 6.00107 7.33333 6.00107C6.9652 6.00107 6.66667 6.2996 6.66667 6.66774V10.3333C6.66667 10.7015 6.9652 11 7.33333 11C7.70147 11 8 10.7015 8 10.3333V8.84627C8.00773 8.83094 8.01747 8.8172 8.02413 8.80094C8.4816 7.682 9.3368 7.2176 9.94547 7.3372C10.4039 7.4272 10.6667 7.84254 10.6667 8.47654V8.33334C10.6667 8.70147 10.9652 9 11.3333 9C11.7015 9 12 8.70147 12 8.33334V8.47667C12 7.2044 11.2944 6.2436 10.2025 6.02907Z"
        fill={color}
      />
      <path
        d="M11.0078 12.4944C11.3633 12.139 11.9263 12.117 12.3076 12.428L12.3809 12.4944L12.4482 12.5687C12.759 12.95 12.7362 13.5121 12.3809 13.8675C12.0017 14.2466 11.387 14.2466 11.0078 13.8675C10.629 13.4883 10.6288 12.8735 11.0078 12.4944Z"
        fill={color}
      />
      <path
        d="M11.7002 10.2969C13.2784 10.297 14.7804 11.3064 15.6631 12.4746L15.831 12.7109L15.8955 12.8232C16.0239 13.0933 16.0021 13.4093 15.831 13.6641V13.665C14.9802 14.9293 13.3837 16.078 11.7002 16.0781C10.122 16.0781 8.62001 15.0686 7.73729 13.9004L7.56835 13.6641C7.37299 13.3731 7.37311 13.0019 7.56835 12.7109V12.71L7.73729 12.4746C8.61998 11.3066 10.1219 10.2969 11.7002 10.2969ZM11.7002 11.4531C10.5747 11.4531 9.37189 12.2185 8.64842 13.1875C9.37189 14.1567 10.5748 14.9219 11.7002 14.9219C12.8255 14.9218 14.0275 14.1563 14.751 13.1875C14.0275 12.2185 12.8255 11.4532 11.7002 11.4531Z"
        fill={color}
      />
    </svg>
  );
};

export default LinkedinViewProfileIcon;
